import { IBenefit, IGroupConfigurationConfig } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";

export class UpdateBenefitCategoryPropertiesTransformer extends BaseJsonTransformer {
    readonly release: IGroupConfigurationConfig;

    constructor(release: IGroupConfigurationConfig) {
        super();
        this.release = release;
    }

    async transformBenefit(benefit: IBenefit): Promise<boolean | void> {
        let category = this.release.cache.map_bcbs_config_category[benefit.bcbs_config_categoryid!];

        // Object.assign(benefit, category);

        if (category) {
            benefit.bcbs_helptext = category.bcbs_helptext;
            benefit.bcbs_name = category.bcbs_name;
            benefit.bcbs_sortorder = category.bcbs_sortorder;
            benefit.bcbs_isenablenonstandard = category.bcbs_isenablenonstandard;
            benefit.bcbs_isfundingtypeenabled = category.bcbs_isfundingtypeenabled;
            benefit._bcbs_supercategoryid_value = category._bcbs_supercategoryid_value;
        }
    }
}
